$(document).ready(function(){
  setTimeout(function(){
    // 기본 autoplay delay 값
    var DEFAULT_AUTOPLAY_DELAY = 3000;
    var VIDEO_AUTOPLAY_DELAY = 30000;

    var main_bnr = new Swiper(".main_slide .swiper-container", {
      speed: 1000,
      loop: true,
      autoplay: {
        delay: DEFAULT_AUTOPLAY_DELAY,
        disableOnInteraction: false,
      },
      spaceBetween: 10,
      navigation: {
          nextEl: '.main_slide .swiper-button-next',
          prevEl: '.main_slide .swiper-button-prev',
      },
      pagination: {
        el: ".main_slide .swiper-pagination",
        type: "bullets",
        clickable: true,
      },
      breakpoints: {
        990: {
          spaceBetween: 20,
        },
      },

      on: {
        init: function () {
          // init 시도
          handleSlideChange(this);
          // 추가 보강: pagination 렌더링 지연을 대비한 안전 호출(한 번)
          setTimeout(() => handleSlideChange(this), 120);
        },
        slideChangeTransitionStart: function () {
          handleSlideChange(this);
        }
      }
    });

    // 안전 보강: Swiper 생성 직후에도 짧게 실행해 둠 (추가 안전망)
    setTimeout(function(){
      if (main_bnr && typeof main_bnr === 'object') {
        handleSlideChange(main_bnr);
      }
    }, 150);

    /**
     * 활성 슬라이드 상태에 따라:
     * - swiper_video면 autoplay delay 30초로 변경
     * - 해당 슬라이드의 visible video 재생, 나머지는 정지
     * - bullet progress 동기화
     *
     * pagination이 아직 준비되지 않으면 내부에서 재시도 (attempt)
     */
    function handleSlideChange(swiper, attempt = 0) {
      var MAX_ATTEMPTS = 10;
      var activeSlide = swiper.slides[swiper.activeIndex];
      var isVideoSlide = activeSlide && activeSlide.classList.contains("swiper_video");
      var newDelay = isVideoSlide ? VIDEO_AUTOPLAY_DELAY : DEFAULT_AUTOPLAY_DELAY;

      // 1) 모든 슬라이드의 비디오 중지 및 초기화
      swiper.slides.forEach(slide => {
        const videos = slide.querySelectorAll("video");
        videos.forEach(v => {
          try {
            v.pause();
            v.currentTime = 0;
          } catch (e) { /* 안전하게 무시 */ }
        });
      });

      // 2) 현재 활성 슬라이드의 visible video만 재생
      if (isVideoSlide) {
        const visibleVideos = Array.from(activeSlide.querySelectorAll("video"))
          .filter(v => v.offsetParent !== null);
        visibleVideos.forEach(v => {
          v.muted = true;
          v.playsInline = true;
          const playPromise = v.play();
          if (playPromise !== undefined) {
            playPromise.catch(err => console.log("video play 실패:", err));
          }
        });
      }

      // 3) autoplay delay 갱신 및 재시작
      swiper.params.autoplay.delay = newDelay;
      if (swiper.autoplay && typeof swiper.autoplay.stop === "function") {
        swiper.autoplay.stop();
        setTimeout(function () {
          swiper.autoplay.start();
        }, 50);
      }

      // 4) pagination bullet 처리 (init 시 bullet이 없으면 재시도)
      var $bullets = $(".main_slide .swiper-pagination-bullet");
      var $activeBullet = $(".main_slide .swiper-pagination-bullet-active");

      if ($activeBullet.length === 0) {
        if (attempt < MAX_ATTEMPTS) {
          setTimeout(function () {
            handleSlideChange(swiper, attempt + 1);
          }, 70);
        } else {
          console.warn("handleSlideChange: pagination not found after retries");
        }
        return;
      }

      // 5) progress 리셋 및 적용
      $bullets.removeClass("progress");
      $activeBullet.css("--progress-time", newDelay + "ms");
      $activeBullet[0] && $activeBullet[0].offsetWidth; // reflow
      $activeBullet.addClass("progress");
    }
  }, 1000);
});
